var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 10.8333L17.6858 13.735C17.7486 13.7768 17.8215 13.8007 17.8968 13.8043C17.972 13.8079 18.0469 13.791 18.1133 13.7555C18.1798 13.7199 18.2353 13.6669 18.2741 13.6023C18.3128 13.5376 18.3333 13.4637 18.3333 13.3883V6.55833C18.3334 6.48502 18.314 6.413 18.2773 6.34954C18.2406 6.28608 18.1878 6.23344 18.1242 6.19692C18.0606 6.1604 17.9886 6.1413 17.9153 6.14155C17.8419 6.14179 17.77 6.16138 17.7067 6.19833L13.3333 8.75",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#87958F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.33333 5H11.6667C12.5871 5 13.3333 5.74619 13.3333 6.66667V13.3333C13.3333 14.2538 12.5871 15 11.6667 15H3.33333C2.41286 15 1.66667 14.2538 1.66667 13.3333V6.66667C1.66667 5.74619 2.41286 5 3.33333 5Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#87958F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.f184525952716b74863383032652afcd.svg";
export { ForwardRef as ReactComponent };